import { LayersIcon } from './icons';
import { compactionText } from '../utils/contextNotes.js';
import './CompactionMarker.css';

/**
 * Séparateur posé au-dessus de la réponse dont le contexte a été condensé.
 * Rôle « note » : lu par les lecteurs d'écran à sa place dans le fil, sans annonce
 * intrusive. Apparition en fondu, supprimée si l'utilisateur réduit les animations.
 */
export function CompactionMarker({ compaction }) {
  const text = compactionText(compaction);
  if (!text) return null;
  const truncated = compaction.mode === 'truncation';
  return (
    <div className={`compaction-marker ${truncated ? 'is-truncation' : ''}`} role="note" aria-label="Contexte de la conversation">
      <span className="compaction-marker__line" aria-hidden="true" />
      <span className="compaction-marker__label">
        <LayersIcon size={14} className="compaction-marker__icon" />
        <span>{text}</span>
      </span>
      <span className="compaction-marker__line" aria-hidden="true" />
    </div>
  );
}
